<template class="teste">
  <div class="black-screen">
    <div>
      <qrcode-stream
      @decode="onDecode"
      :camera="facingMode"
      >
      </qrcode-stream>
    </div>
    <v-btn v-if="iOS" @click="$_switchCamera"
    plain outlined fab class="switch-camera">
      <v-icon color="white">mdi-camera-switch</v-icon>      
    </v-btn>
    <footer class="footer" v-if="footer">{{mensagem}}</footer>
    <v-btn v-if="botaoteste" @click="onDecode(nroteste)">{{nroteste}}</v-btn>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';
import { OPLOCAL_STORAGE } from '@/constants/STORAGE';

export default {
  name: 'QRView',

  components: {
    QrcodeStream,
  },

  data() {
    return {
      backToValueRoute: '',
      tipo: this.$route.params.tipo,
      footer: false,
      mensagem: 'Posicione o QR-Code em frente a câmera',
      nroteste: 'AJT0001/2610',
      iOS: false,
      facingMode: 'rear',
      qrodem: null,
      qrdoca: null,
      qrlocal: null,
      qrdun: null,
    };
  },

  methods: {
    async onDecode(content) {
      if (this.qrodem === 'true') {
        console.log('ordem decode', content, content.replace(/^0+/, ''));
        sessionStorage.setItem(OPLOCAL_STORAGE.qr, content.replace(/^0+/, ''));
        this.$router.back();
        return;
      }
      if (this.qrdoca) {
        console.log('doca decode', content, content);
        sessionStorage.setItem(OPLOCAL_STORAGE.qr, content);
        this.$router.back();
        return;
      }
      if (this.qrlocal) {
        console.log('doca decode', content, content);
        sessionStorage.setItem(OPLOCAL_STORAGE.qr, content);
        this.$router.back();
        return;
      }
      if (this.qrdun) {
        // QR da Ordem Produção DUN: o conteúdo é o código DUN da aberturalote
        // (ex.: 27898962664418), armazenado BRUTO/COMPLETO — sem o corte de
        // dígitos do fluxo do Lote C, que truncava os 2 últimos.
        console.log('dun decode', content);
        sessionStorage.setItem(OPLOCAL_STORAGE.qr, content.trim());
        sessionStorage.removeItem('qrdun');
        this.$router.back();
        return;
      }
      const newContent = content.replace("-", "");
      const indexBarra = content.indexOf('/');
      if (newContent[indexBarra + 3]) {
        const digitos = `${newContent[indexBarra + 3]}${newContent[indexBarra + 4] || ''}`
        sessionStorage.setItem(OPLOCAL_STORAGE.numerobag, digitos);
        if (newContent[indexBarra + 4]) {
          sessionStorage.setItem(OPLOCAL_STORAGE.qr, newContent.slice(0, -2));
        } else {
          sessionStorage.setItem(OPLOCAL_STORAGE.qr, newContent.slice(0, -1));
        }
        this.$router.back();
        return;
      } 
      sessionStorage.setItem(OPLOCAL_STORAGE.qr, newContent);
      this.$router.back();
    },

    $_verificaOS() {
      if (/iPad|iPhone|Mac|iPod/.test(navigator.userAgent)) {
        this.iOS = true;
      } else {
        this.iOS = false;
      }
    },
    
    $_switchCamera() {
      this.facingMode = this.facingMode === 'rear' ? 'front' : 'rear';
    },
  },

  created() {
    this.$_verificaOS();
    setTimeout(() => {
      this.footer = true;
      sessionStorage.setItem(OPLOCAL_STORAGE.qr, null);
    }, 1100);
    this.qrodem = sessionStorage.getItem('qrordem');
    this.qrdoca = sessionStorage.getItem('qrdoca');
    this.qrlocal = sessionStorage.getItem('qrlocal');
    this.qrdun = sessionStorage.getItem('qrdun');
    this.botaoteste = (process.env.NODE_ENV !== 'production');
  },
};

</script>

<style scoped>

  .black-screen {
    background-color: #343434;
    height: 100%;
  }

  .footer {
    background-color: #343434;
    display: flex;
    justify-content: center;
    color: #eee;
    z-index: 2;
    flex: 1;
  }

  .teste {
    background-color: #343434;
  }

  .switch-camera {
    border: none;
    display: block;
    float: right;
  }
</style>>
